import React, { memo } from 'react';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { selectMonthlyTotalsFilteredWithFallbackMonths, selectMonthlyTotals, selectMonthlyCategories, } from 'features/analytics/selectors';
import { useAppSelector } from 'store/hooks';
import { noop } from 'lodash';
import AnalyticsCarouselItem from 'features/analytics/components/AnalyticsCarouselItem';
import { useSharedValue } from 'react-native-reanimated';
import { selectCurrentPaydayRange } from 'reducers/selectors';
import { CardView, rem } from 'design-system';
const index = 0;
const WalkthroughIncomeSpendingCard = ({ itemPosition }) => {
    const styles = useStyles(styleSet);
    const positionAnimatedValue = useSharedValue(0);
    const filteredMonthlyTotals = useAppSelector(selectMonthlyTotalsFilteredWithFallbackMonths);
    const monthlyCategories = useAppSelector(selectMonthlyCategories);
    const currentPaydayRange = useAppSelector(selectCurrentPaydayRange);
    const unfilteredMonthlyTotals = useAppSelector(selectMonthlyTotals);
    const monthlyTotals = filteredMonthlyTotals?.results || unfilteredMonthlyTotals;
    const item = monthlyTotals[0];
    const effectiveMonthlyTotalsStep = filteredMonthlyTotals?.step ??
        (currentPaydayRange ? 'payperiod' : 'month');
    if (!itemPosition || !item) {
        return null;
    }
    return (<CardView noMargin style={styles.container} pointerEvents="none">
        <AnalyticsCarouselItem index={index} blurValue={false} value={item.value} currentTo={item.to} income={item.income} currentFrom={item.from} spending={item.spending} currency={item.currency} onPressUpgradeForSearch={noop} spendingBreakdown={item.spendBreakdown} previousTo={monthlyTotals[index + 1]?.to} positionAnimatedValue={positionAnimatedValue} previousFrom={monthlyTotals[index + 1]?.from} monthlyTotalsStep={effectiveMonthlyTotalsStep} previousSpending={monthlyTotals[index + 1]?.spending} monthlyCategories={monthlyCategories[`${item.from}|${item.to}`]} spendingBreakdownPrevious={monthlyTotals[index + 1]?.spendBreakdown}/>
      </CardView>);
};
export default memo(WalkthroughIncomeSpendingCard);
const styleSet = createStyleSheets((colors) => ({
    container: {
        padding: rem(4),
        marginTop: rem(12),
        marginHorizontal: rem(12),
        backgroundColor: colors.background.dark,
    },
}));
